import React from "react";

const ViewedIcon = () => {
  return (
    <div>
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 9C1 9 2.6 4 9 4M9 4C15.4 4 17 9 17 9M9 4V1M15 2L13 4.5M3 2L5 4.5M12 10C12 11.6569 10.6569 13 9 13C7.3431 13 6 11.6569 6 10C6 8.3431 7.3431 7 9 7C10.6569 7 12 8.3431 12 10Z"
          stroke="#111827"
          stroke-width="1.47"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default ViewedIcon;
